import styled from "styled-components";
import { Card, Type } from "discover.medical.react-component-library";

export const Placard = styled(Card)`
  max-width: 315px;
`;

export const PlacardSection = styled(Card)`
  > img {
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const PlacardType = styled(Type)`
  font-style: ${(props) => (props.italic ? "italic" : null)};
`;
